var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading ? _c('Loader', {
    attrs: {
      "content-id": _vm.assetID,
      "message": 'Fetching Asset Details'
    }
  }) : [_vm.asset && _vm.genesisTx ? _c('AssetSummary', {
    attrs: {
      "asset": _vm.asset,
      "genesis-tx": _vm.genesisTx
    }
  }) : _vm._e(), !_vm.txRequestError ? _c('section', {
    staticClass: "card transactions"
  }, [_c('TxHeader'), _c('TxInteractive', {
    attrs: {
      "transactions": _vm.transactions,
      "assets-loaded": _vm.assetsLoaded,
      "loading": _vm.loading,
      "chains": _vm.chains
    },
    on: {
      "change": _vm.fetchTx
    }
  })], 1) : _vm._e(), !_vm.txLoading && _vm.txRequestError ? _c('HTTPError', {
    attrs: {
      "id": _vm.assetID,
      "title": 'There was an error fetching asset transactions.',
      "status": _vm.txRequestErrorStatus,
      "message": _vm.txRequestErrorMessage,
      "support-u-r-l": 'https://chat.avalabs.org',
      "is-margin": true
    }
  }) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }